module.exports = __webpack_public_path__ + "static/media/settings.efdb9fed.svg";